import * as Sentry from "@sentry/react"
import { MIMBER_COLORS, themeTokens } from "@mimber/ui-core"

const environment =
  import.meta.env.VITE_SENTRY_ENVIRONMENT ||
  import.meta.env.MODE ||
  "development"
const dsn = import.meta.env.VITE_SENTRY_DSN

export const initializeSentry = () => {
  if (!dsn) {
    console.warn(
      "Sentry DSN not configured. Error tracking will not be available."
    )
    return
  }

  Sentry.init({
    dsn,
    environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
      // Send console.log, console.warn, and console.error calls as logs to Sentry
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
      // User Feedback widget - manually triggered via the "Report an Issue" action
      Sentry.feedbackIntegration({
        autoInject: false,
        colorScheme: "system",
        buttonLabel: "Report an Issue",
        submitButtonLabel: "Send Report",
        formTitle: "Report an Issue",
        fontFamily: themeTokens.fontFamily,
        themeLight: {
          foreground: MIMBER_COLORS.text,
          background: "#FFFFFF",
          accentForeground: "#FFFFFF",
          accentBackground: MIMBER_COLORS.azure,
          // `border` must be a full CSS border shorthand (width + style + color),
          // not just a color, or the browser drops the declaration entirely
          border: "1px solid rgba(14, 58, 93, 0.35)",
          successColor: MIMBER_COLORS.success,
          errorColor: MIMBER_COLORS.error,
        },
        themeDark: {
          foreground: MIMBER_COLORS.darkText,
          background: MIMBER_COLORS.darkBgElevated,
          accentForeground: "#FFFFFF",
          accentBackground: MIMBER_COLORS.azure,
          border: "1px solid rgba(168, 182, 196, 0.45)",
          successColor: MIMBER_COLORS.success,
          errorColor: MIMBER_COLORS.error,
        },
      }),
    ],

    // Enable logs to be sent to Sentry
    enableLogs: true,

    // Performance monitoring
    tracesSampleRate: parseFloat(
      import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || "1.0"
    ),
    tracePropagationTargets: ["localhost", /^https:\/\/.*\.mimber\.com/],

    // Session Replay - only capture on errors
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    // Privacy settings
    beforeSend(event) {
      // Scrub sensitive data from error events
      if (event.request?.headers) {
        delete event.request.headers["authorization"]
        delete event.request.headers["cookie"]
      }
      return event
    },
  })
}
